import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { color, size } from '../helpers/variables';
import { fontFamilyHeading, dynamicFontSize } from '../helpers/mixins';
import { Section } from '../Section';
import { Container } from '../Container';
import { Heading } from '../Heading';
import { Paragraph } from '../Paragraph';
import { ImageZoomAnimation } from '../helpers/animations';

export const StartPageBlock = {};

StartPageBlock.PageHeading = Heading.extend`
  position: relative;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: normal;
  text-align: center;
  color: ${color.black};
  z-index: 1;
  padding: 20px 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    ${dynamicFontSize(16, 24)};
    position: relative;
    z-index: 1;
    background-color: #d8d9d1;
    padding: 0 0.5em;
    top: -1px;
  }

  &:before {
    content: '';
    position: absolute;
    height: 1px;
    width: 100%;
    max-width: 480px;
    background-color: ${color.black};
    z-index: -1;
  }

  @media screen and (min-width: ${size.large}px) {
    padding: 34px 0;
  }
`;

StartPageBlock.Heading = Heading.h2;

StartPageBlock.HeroHeading = styled.p`
  ${fontFamilyHeading};
  font-size: 36px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  margin-bottom: 20px;
  color: ${color.black};
  width: 100%;

  @media screen and (min-width: ${size.large}px) {
    color: ${props => (props.isDark ? color.white : color.black)};
    margin-top: 20px;
  }

  @media screen and (min-width: ${size.xLarge + 100}px) {
    font-size: 44px;
  }

  ${props =>
    props.onDarkBackground &&
    css`
      color: ${color.white};
    `};
`;

StartPageBlock.HeroContent = styled(Link)`
  text-decoration: none;
  width: 280px;
  height: 280px;
  background-color: ${props => (props.isLight ? `rgba(255, 255, 255, 0.6)` : `rgba(0, 0, 0, 0.6)`)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  transition: opacity 250ms ease-out;

  @media screen and (min-width: ${size.xLarge + 100}px) {
    width: 360px;
    height: 360px;
  }
`;

StartPageBlock.HeroLinkBase = styled(Link)`
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.5px;
  text-align: center;
  color: ${props => (props.isDark ? color.white : color.black)};
  text-decoration: none;
  text-transform: uppercase;
  display: block;
  padding: 10px;

  @media screen and (min-width: ${size.large}px) {
    font-size: 14px;
  }

  ${props =>
    props.onDarkBackground &&
    css`
      color: ${color.white};
    `};
`;

StartPageBlock.HeroLink = StartPageBlock.HeroLinkBase.withComponent(Link);

StartPageBlock.HeroLinkAsP = StartPageBlock.HeroLinkBase.withComponent('p').extend`
  position: relative;
  &:before,
  &:after {
    content: '';
    position: absolute;
    right: 0;
    left: 0;
    height: 1px;
    display: block;
    opacity: 0;
    transition: opacity 250ms ease-out, transform 250ms ease-out;
    background-color: ${props => (props.isDark ? color.white : color.black)};
  }
  
  &:before {
    bottom: -5px;
    transform: translateY(10px);
  }
  
  &:after {
    top: -5px;
    transform: translateY(-10px);
  }
  
  ${StartPageBlock.HeroContent}:hover & {
    &:before,
    &:after {
      opacity: 1;
      transform: translateY(0);
    }
  }
  &:hover {
    &:before,
    &:after {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

StartPageBlock.Section = Section;
StartPageBlock.SectionFix = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 128px;
  background: ${props => (props.backgroundColor ? props.backgroundColor : color.white)};
`;
StartPageBlock.Container = Container.extend`
  padding-top: 0;
  padding-bottom: 30px;

  @media screen and (min-width: ${size.large}px) {
    padding-bottom: 0;
  }
`;
StartPageBlock.Paragraph = Paragraph;
StartPageBlock.HeroImageContainer = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 72.5%;
  position: relative;
  overflow: hidden;

  @media screen and (min-width: ${size.large}px) {
    padding-bottom: 47.16%;
  }
`;

StartPageBlock.HeroContentContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding: 0 7%;
  justify-content: ${props => (props.alignRight ? 'flex-end' : 'flex-start')};
`;

StartPageBlock.HeroImage = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url("${props => props.image}");
  background-size: cover;
  background-position: center;
  ${ImageZoomAnimation};
`;

StartPageBlock.InstagramHashTag = styled.a`
  display: block;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.5px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  color: ${color.white};
  margin-bottom: 30px;
  margin-top: 10px;
`;



// WEBPACK FOOTER //
// ./src/styles/blocks/StartPageBlock.js